import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import type { Prismic } from '@landsbankinn/prismic';
import { Button, theme } from '@landsbankinn/ui';
import React, { useState } from 'react';
import { SmartBookingCustomerType } from '../../../../../__generated__/globalTypes';
import {
  AppointmentStep,
  useAppointmentContext,
} from '../../../book-appointment/BookAppointment';
import { ImageContainer } from '../../../book-appointment/shared/ImageContainer';
import { Title } from '../../../book-appointment/shared/Title';
import res from './Intro.res';

const StyledButton = styled(Button)`
  width: 100%;
  margin-bottom: 28px;
`;

interface IProps {
  image?: Prismic.Image;
  defaultCustomerType?: SmartBookingCustomerType;
  title: string;
  copy: string;
}

export function Intro({ defaultCustomerType, image, title, copy }: IProps) {
  const [animate, toggle] = useState(false);
  const { setCurrentStep, dispatch } = useAppointmentContext();
  const { r } = useResource();

  return (
    <ImageContainer
      image={image}
      reverse={animate}
      onRest={() => {
        if (animate) {
          setCurrentStep?.(AppointmentStep.SelectService);
        }
      }}
    >
      <Title
        title={title ?? r(res.bookAppointment)}
        subTitle={copy ?? r(res.subTitle)}
      />

      <>
        {defaultCustomerType && (
          <StyledButton
            title={r(res.bookAppointment)}
            bg={theme.colors.primary}
            onClick={() => {
              if (dispatch) {
                dispatch({
                  type: 'selectCustomerType',
                  customerType: defaultCustomerType,
                });
              }
              toggle(true);
            }}
          />
        )}
        {!defaultCustomerType && (
          <div>
            <StyledButton
              title={r(res.person)}
              bg={theme.colors.primary}
              onClick={() => {
                if (dispatch) {
                  dispatch({
                    type: 'selectCustomerType',
                    customerType: SmartBookingCustomerType.Person,
                  });
                }
                toggle(true);
              }}
            />
            <StyledButton
              title={r(res.corporate)}
              bordered
              bg={theme.colors.primary}
              onClick={() => {
                if (dispatch) {
                  dispatch({
                    type: 'selectCustomerType',
                    customerType: SmartBookingCustomerType.Company,
                  });
                }
                toggle(true);
              }}
            />
          </div>
        )}
      </>
    </ImageContainer>
  );
}
